(ns entities.review.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.review.specs :as sp]))

(def path [:entities :review])

(rf/reg-entity
  :review
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/review)
                :success [:review/fetched]
                :error [:review/fetch-errored]
                :cancellable? true}})

   :post
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/create-review {:input data})
                :success [:review/created]
                :error [:review/create-errored]}})
   })

(rf/reg-event-db
  :review/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :review])))

(rf/reg-event-db
  :review/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :review])))

(rf/reg-event-db
  :review/created
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:create-review])))

(rf/reg-event-db
  :review/create-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:create-review])))

